<div>
    <div class="container-fluid top-nav" style="overflow: hidden;">
        <div class="card ml-3 p-1 mt-0">
            <div class="row">
                <div class="col-1">
                    <button (click)="previousMonth()" matTooltip="{{ 'planning.lastmonth' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" class="material-icons portal-icon btn center align-middle p-0 rounded-circle w-35 h-35 f-20 lh-35" >arrow_back_ios_new</button>
                </div>
                <div class="col-10">
                    <p class="mb-0 lh-35 align-middle"><b>{{monthName | titlecase  }} {{ 'planning.overview' | trans }}</b></p>
                </div>
                <div class="col-1">
                    <button (click)="nextMonth()" matTooltip="{{ 'planning.nextmonth' | trans }}" matTooltipPosition="above" matTooltipShowDelay="500" class="float-right material-icons portal-icon btn center pl-2 align-middle p-0 rounded-circle w-35 h-35 f-20 lh-35" >arrow_forward_ios_new</button>
                </div>
            </div>
        </div>
        <app-chart *ngIf="data.length > 20" [data]="data" [people]="people" [pp]="pp" (doneloading)="endLoading($event)"></app-chart>
    </div>
</div>